module.exports = __webpack_public_path__ + "img/fund_password.cf01e887.png";